import axios from "axios";

const actions = {
  async industryList(context, payload) {
    try {
      const response = await this.$api.call("insurance.industryList", payload);
      const responseData = response.data;

      context.commit("mutationIndustryList", responseData);

      return response;
    } catch (error) {
      context.commit("mutationIndustryList", []);
      throw error;
    }
  },

  async productCategoryList(context, payload) {
    try {
      const response = await this.$api.call(
        "insurance.productCategoryList",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationProductCategoryList", responseData);

      return response;
    } catch (error) {
      context.commit("mutationProductCategoryList", []);
      throw error;
    }
  },

  async deleteProductCategory(_context, payload) {
    try {
      const response = await this.$api.call(
        "insurance.deleteProductCategory",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  setAddProductCategory(context, payload) {
    context.commit("mutationAddProductCategory", payload);
  },

  setEditProductCategory(context, payload) {
    context.commit("mutationEditProductCategory", payload);
  },

  async addProductCategory(_context, payload) {
    try {
      const response = await this.$api.call(
        "insurance.addProductCategory",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async editProductCategory(_context, payload) {
    try {
      const response = await this.$api.call(
        "insurance.editProductCategory",
        payload,
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  async delete(_context, payload) {
    try {
      const response = await this.$api.call("organization.delete", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async getPresignUrl(_context, payload) {
    try {
      const response = await this.$api.call("insurance.getPresignUrl", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async hitPresignUrl(context, { buffer, url }) {
    try {
      const response = await axios.put(url, buffer, {
        onUploadProgress: (progressEvent) => {
          const progress = (progressEvent.loaded / progressEvent.total) * 100;
          context.commit(
            "mutationUploadProgress",
            parseInt(Math.round(progress), 10),
          );
        },
      });
      const responseData = response.data;

      // reset uploadProgress to 0 (init state)
      context.commit("mutationUploadProgress", 0);
      return responseData;
    } catch (error) {
      // reset uploadProgress to 0 (init state)
      context.commit("mutationUploadProgress", 0);

      throw error;
    }
  },

  async getInsuranceById(context, payload) {
    try {
      const response = await this.$api.call(
        "insurance.getInsuranceById",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async getlistProductsByInsuranceId(context, payload) {
    try {
      const response = await this.$api.call(
        "insurance.getlistProductsByInsuranceId",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async addInsurerProduct(context, payload) {
    try {
      const response = await this.$api.call(
        "insurance.addInsurerProduct",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async updateInsurerProduct(context, payload) {
    try {
      const response = await this.$api.call(
        "insurance.updateInsurerProduct",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async getInsuranceProduct(context, payload) {
    try {
      const response = await this.$api.call(
        "insurance.getInsuranceProduct",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async deleteInsurerProduct(context, payload) {
    try {
      const response = await this.$api.call(
        "insurance.deleteInsurerProduct",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async getPresignUrlInsurerProduct(context, payload) {
    try {
      const response = await this.$api.call(
        "insurance.getPresignUrlInsurerProduct",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async getPreviewUrlInsurerProduct(context, payload) {
    try {
      const response = await this.$api.call(
        "insurance.getPreviewUrlInsurerProduct",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async updateInsurerProductStatus(context, payload) {
    try {
      const response = await this.$api.call(
        "insurance.updateInsurerProductStatus",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async getValidInsuranceById(context, payload) {
    try {
      const response = await this.$api.call("organization.list", {
        query: {
          type: "INSURER",
          code: payload.params.organizationId,
        },
      });

      if (response?.data?.length === 0) {
        throw new Error(
          `organization with id: ${payload.params.organizationId}, not found!`,
        );
      }
      const [selectedData] = response.data;
      context.commit("mutationSetInsurerDetail", selectedData);
      context.commit("organization/mutationOrganization", selectedData, {
        root: true,
      });

      return response;
    } catch (error) {
      context.commit("mutationSetInsurerDetail", {});
      context.commit(
        "organization/mutationOrganization",
        {},
        {
          root: true,
        },
      );
      throw error;
    }
  },

  async getInsurerProduct(context, payload) {
    try {
      const response = await this.$api.call("insurance.productDetail", {
        params: {
          productCode: payload.params.productCode,
        },
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default actions;
